import { render, staticRenderFns } from "./LoginDataRealTime.vue?vue&type=template&id=18b496aa&scoped=true&"
import script from "./LoginDataRealTime.vue?vue&type=script&lang=js&"
export * from "./LoginDataRealTime.vue?vue&type=script&lang=js&"
import style0 from "./LoginDataRealTime.vue?vue&type=style&index=0&id=18b496aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b496aa",
  null
  
)

export default component.exports